<mat-card appearance="outlined" class="container-fluid container">
  <form [formGroup]="commentForm" #form="ngForm">
    <mat-card-title class="container-header">
      <h3 mat-dialog-title>{{title}}</h3>
    </mat-card-title>
    <hr>
    <mat-card-content class="container-content">

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Commentaire</mat-label>
        <textarea matInput formControlName="Comment" matTextareaAutosize matAutosizeMinRows=3 matAutosizeMaxRows=3 [ngClass]="{ 'is-invalid': submitted && commentForm.errors.requiredIfIsNotValid}"
          maxlength="100">
          </textarea>
      </mat-form-field>

    </mat-card-content>
    <mat-card-footer class="container-footer">
      <div class="modal-footer d-table w-100">
        <div class="d-table-cell">
          <button type="button" mat-stroked-button class="currentBtn" data-dismiss="modal" (click)="close(false);">Annuler</button>
        </div>
        <div class="d-table-cell tar">
          <button type="submit" mat-stroked-button class="currentBtnColor" (click)="onSubmit()" [disabled]="!IsFormValid">Valider</button>
        </div>
      </div>
    </mat-card-footer>
  </form>
</mat-card>